module.exports = __webpack_public_path__ + "img/tut.47c0cae3.png";